function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable max-len */
import React from 'react';
import withCssProps from '../../../hocs/withCssProps';
import { StyledIcon } from './StyledIcon';
export var Itick = withCssProps(function (props) {
  return /*#__PURE__*/React.createElement(StyledIcon, _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "24/Tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x94\xB9Icon Color",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.56836 15.9422L4.81501 12.1848C4.39678 11.7661 3.7319 11.7661 3.31367 12.1848C2.89544 12.6035 2.89544 13.2691 3.31367 13.6878L7.80697 18.186C8.2252 18.6047 8.9008 18.6047 9.31903 18.186L20.6863 6.817C21.1046 6.39831 21.1046 5.7327 20.6863 5.31402C20.2681 4.89533 19.6032 4.89533 19.185 5.31402L8.56836 15.9422Z",
    fill: "#63A105"
  })));
});